/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {homeMock, rankMock, stageDataMock} from './mock'

enum TASK_STATUS {
  未完成,
  已完成未领取,
  已完成已领取,
}

export const getHomepage = createAsyncThunk(
  'CPRelationV2/getHomepage',
  async (p: any, store: any) => {
    // return new Promise((res) => {
    //   setTimeout(() => {
    //     res({...homeMock, ...p} as any)
    //   }, 1000)
    // })
    const resp = await http.post(
      '/live/gift/intimate_cp_home',
      {...p},
      {
        store: window.store,
      }
    )
    if (p?.uncheck_draw_card) {
      return {
        ...resp?.data?.data,
        fortune_done: true,
      }
    }
    return resp?.data?.data
  }
)

export const getRankPage = createAsyncThunk(
  'CPRelationV2/getRankPage',
  async (p: any, store: any) => {
    // return rankMock

    const resp = await http.post(
      '/live/gift/intimate_cp_rank',
      {...p},
      {
        store: window.store,
      }
    )
    return resp?.data?.data
  }
)

export const getStageList = createAsyncThunk(
  'CPRelationV2/getStageList',
  async (p: any, store: any) => {
    // return {...stageDataMock, ...p}

    const resp = await http.post(
      '/live/gift/intimate_cp_stage_list',
      {...p},
      {
        store: window.store,
      }
    )
    return resp?.data?.data
  }
)

const initialState = {
  homepage: null,
  rankData: null,
  stageData: null,
}

export const CPRelationSlice = createSlice({
  name: 'CPRelationV2',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHomepage.fulfilled, (state, action) => {
      const data = action.payload || {}
      state.homepage = data
    })
    builder.addCase(getRankPage.fulfilled, (state, action) => {
      const data = action.payload || {}
      state.rankData = data
    })
    builder.addCase(getStageList.fulfilled, (state, action) => {
      const data = action.payload || {}
      const stages: any =
        [...(data?.stages || [])]?.sort((a, b) => a?.stage_id - b?.stage_id) ||
        []

      const cur_stage =
        data?.cur_stage_id >= data?.endless?.stage_id
          ? data?.endless?.stage_id - 1
          : stages?.findLastIndex((item) => item?.status !== TASK_STATUS.未完成)

      const cur_stage_index = cur_stage >= 0 ? cur_stage + 1 : 0

      state.stageData = {...data, cur_stage_index, stages}
    })
  },
})

export default CPRelationSlice.reducer

export const CPRelationSliceActions = CPRelationSlice.actions

export const useReducerState = () => {
  const data = useSelector((state) => {
    return state.CPRelationV2
  })
  return data
}
